import React, { useState } from "react";
import {
  Divider,
  Tooltip,
  Button,
  Form,
  Input,
  Modal,
  InputNumber,
} from "antd";
import {
  TrophyOutlined,
  DollarOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
function Wallet({ balance }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const DIPOSITIWALLET = gql`
    mutation DepositWallet($amount: Int!) {
      createWalletInvoice(amount: $amount) {
        id
      }
    }
  `;
  const [runCreateWalletInvoice, createWalletInvoice] = useMutation(
    DIPOSITIWALLET,
    {
      onError(err) {
        console.log("خطا: " + err.message);
        Modal.error({
          title: "مشکلی پیش آمده!",
          content: "لطفا دوباره تلاش کنید!",
          bodyStyle: { direction: "rtl" },
          okText: "باشه",
        });
      },
      onCompleted({ createWalletInvoice }) {
        navigate(`/invoice/${createWalletInvoice.id}`);
      },
    }
  );
  const depositWallet = (depositForm) => {
    runCreateWalletInvoice({
      variables: {
        amount: depositForm?.amount * 10,
      },
    });
  };
  const balanceToman = balance
    ? balance / 10
    : balance;

  const onCreate = (values) => {
    setOpen(false);
  };
  return (
    <div className="walletWrapper">
      <span>
        <Divider style={{ fontSize: "15px", fontWeight: "bold", color:"#dddddde6" }}>
          موجودی کیف پول: {balanceToman.toLocaleString()}
        </Divider>
      </span>
      <div className="walletDetail">
        <div>
          <span>
            <DollarOutlined /> موجودی نقد:
          </span>
          <span>{balanceToman.toLocaleString()} تومان</span>
        </div>
      </div>
      <div className="walletBtns">
        <Button
          type="primary"
          icon={<RiseOutlined />}
          onClick={() => {
            setOpen(true);
          }}
        >
          افزایش موجودی
        </Button>
        <Link to="/transactions">تراکنش ها</Link>
      </div>
      <CollectionCreateForm
        open={open}
        onCreate={depositWallet}
        onCancel={() => {
          setOpen(false);
        }}
      />
    </div>
  );
}

export default Wallet;

const CollectionCreateForm = ({ open, onCreate, onCancel }) => {
  const [form] = Form.useForm();
  return (
    <Modal
      open={open}
      title=""
      okText="پرداخت"
      cancelText="انصراف"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={{
          modifier: "public",
        }}
      >
        <Form.Item
          name="amount"
          label="میزان افزایش موجودی (تومان)"
          rules={[
            {
              required: true,
              message: "لطفا مبلغ افزایش موجودی را وارد کنید",
            },
          ]}
        >
          <InputNumber
            formatter={(value) =>
              value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
            className="form-input"
            placeholder={"مبلغ"}
            style={{ textAlign: "left", width: "100%" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
